import { Check, Clock, ClockFill, CloseCircle } from 'icons';
import { palette } from 'utils';

export const delegateStatusDocument = {
  waiting: { text: 'waiting', icon: ClockFill, color: palette['yellow-125'] },
  approved: { text: 'approved', icon: Check, color: palette['green-125'] },
  rejected: { text: 'rejected', icon: CloseCircle, color: palette['red-125'] },
  expired: { text: 'expired', icon: Clock, color: palette['red-75'] }
};
